<template>
  <div v-if="_visible" class="versionManage">
    <div v-show="versionView" class="versionManage-main">
      <module-title title="版本管理">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            添加版本
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="back">
            返回
          </el-button>
        </div>
      </module-title>
      <div class="versionManage-main-contain">
        <el-table
          v-loading="listLoading"
          :data="versionManage"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="应用名称" prop="appName" align="center" />
          <el-table-column label="包名" prop="packageName" align="center" show-overflow-tooltip />
          <el-table-column label="版本号" prop="versionName" align="center" width="100" />
          <el-table-column label="升级描述" prop="introduction" align="center" show-overflow-tooltip />
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.status == '1' ?'启用':'禁用' }}
            </template>
          </el-table-column>
          <el-table-column label="发布时间" prop="createDate" align="center" width="128">
            <template slot-scope="scope">
              {{ formatTimeToStr(scope.row.createDate) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300px">
            <template slot-scope="scope">
              <el-button
                v-show="scope.row.status == 0"
                type="success"
                size="small"
                icon="el-icon-success"
                style="margin-left:10px"
                @click="handleUseEdit(scope.row)"
              >
                启用
              </el-button>
              <el-button
                v-show="scope.row.status == 1"
                type="warning"
                size="small"
                icon="el-icon-warning-outline"
                @click="handleUseEdit(scope.row)"
              >
                禁用
              </el-button>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="opAddOrEdit('edit',scope.row)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增和编辑版本 -->
    <add-version
      :visible.sync="hiddenVariable.addVersionVisible"
      :handle-type="handleType"
      :update-row="updateRow"
      :app-name="appName"
      :app-id="searchForm.appId"
    />
    <el-dialog :visible.sync="dialogImageVisible" title="预览图片">
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
  </div>
</template>

<script>

import AddVersion from './addVersion';
import { formatTimeToStr } from '@/utils/index';
import {
  versionList,
  versionStatus
} from '@/api/productOperation/classRoom/applicationList';
export default {
  name: 'VersionManage',
  components: {
    AddVersion
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    appId: {
      type: String,
      required: true
    },
    appName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      versionView: true, // 版本管理页面
      // 弹框标题
      handleType: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        // 新增版本
        addVersionVisible: false
      },
      // 搜索表单
      searchForm: {
        appId: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      versionManage: [],
      ajaxLoading: false, //  表单提交loading
      dialogImageVisible: false,
      updateRow: {}, // 编辑版本row
      dialogImageUrl: '',
      addVersionForm: {
        appId: '',
        packageName: '',
        versionName: ''
      }
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    formatTimeToStr() {
      return formatTimeToStr;
    }
  },
  mounted() {
    this.fetchversionManage();
  },
  methods: {
    // 返回
    back() {
      this._visible = false;
      this.$parent.fetchApplicationList();
    },
    openView() { // 打开应用页面
      this.versionView = true;
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchversionManage();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchversionManage();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchversionManage();
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.updateRow = row;
      this.handleType = type;
      this.hiddenVariable.addVersionVisible = true;
      this.versionView = false;
    },
    // 启用禁用
    handleUseEdit(row) {
      this.$confirm(
        `确定要${row.status === 1 ? '禁用' : '启用'}该应用版本么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var id = row.status;
          const form = {
            status: id === 0 ? 1 : 0
          };
          return versionStatus(row.id, form);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `${row.status === '1' ? '禁用' : '启用'}成功`,
            showClose: false,
            duration: 2000
          });
          this.fetchversionManage();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取版本列表
    fetchversionManage() {
      this.listLoading = true;
      this.searchForm.appId = this.appId;
      versionList(this.searchForm)
        .then(result => {
          if (result.data && result.data.list && result.data.list.length) {
            this.versionManage = result.data.list;
            this.searchForm.total = result.data.total;
          } else {
            this.versionManage = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.versionManage = [];
          this.searchForm.total = 0;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.versionManage {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 300px;
}
.handle-form-textarea {
  width: 400px;
}
.eidt-pictures {
  float: left;
  .eidt-pictures-item {
    display: inline-block;
    position: relative;
    img {
      width: 148px;
      height: 148px;
      margin-right: 10px;
      border-radius: 6px;
      cursor: pointer;
    }
    .el-icon-error {
      position: absolute;
      top: 0;
      right: 10px;
      cursor: pointer;
      font-size: 16px;
      color: #f56c6c;
    }
  }
}
.el-upload-picture {
  float: left;
}
</style>
